module.exports = __webpack_public_path__ + "static/img/error-dark.dee1eb51.svg";